import { Injectable } from '@angular/core';

import { SelectedAccountStore } from '@core/stores/selected-account-store.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { DASHBOARDS } from '@app/shared/enum/dashboards';
import { ENDPOINTS } from '@core/constants/endpoints';
import { AuthenticationService } from '@core/authentication/authentication.service';

@Injectable()
export class DashboardGuard {
    constructor(
        private authenticationService: AuthenticationService,
        private selectedAccountStore: SelectedAccountStore,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        let dashboard = route.data['dashboardType'] as DASHBOARDS;
        if (dashboard === DASHBOARDS.EXPLORE_ASSET) {
            dashboard = DASHBOARDS.EXPLORE;
        }

        const account =
            this.authenticationService.user.serviceAccount ??
            this.selectedAccountStore.selectedAccount;

        if (!(dashboard && account.hasDashboard(dashboard))) {
            this.router.navigate([ENDPOINTS.urls.pageNotFound]).catch(() => {});
        }
        return true;
    }
}
